var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"header",staticClass:"header",class:{
    'header--no-scroll': _vm.noScroll,
    'header--sticky': _vm.sticky,
    'header--pointer': _vm.hasBackSlot,
  }},[(_vm.hasBackSlot)?_c('div',{staticClass:"header__back"},[_vm._t("back")],2):_vm._e(),_c('div',{staticClass:"header__title"},[_vm._t("default")],2),(_vm.hasActionSlot)?_c('div',{staticClass:"header__action"},[_vm._t("action")],2):_vm._e(),(_vm.hasTextSlot)?_c('div',{staticClass:"header__text"},[_vm._t("text")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }